import { emitAll14ajoawrvg9d0 as emitAll } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import {
  Builder16nv925388a0q as Builder,
  ApolloResponse1aeginapbuksm as ApolloResponse,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstancevdtg3uvqmv7f as Companion_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstancesbkvvo7sip2d as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delay1yesbzthrp6ln as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { waitForNetwork170u1djobkhlr as waitForNetwork } from '../network/NetworkMonitor.mjs';
import { flow3tazazxj2t7g4 as flow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
import { retryWhenf2aqzvtrvxoo as retryWhen } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  OfflineException_getInstanceq1tpn78onqx1 as OfflineException_getInstance,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_OfflineApolloException() {
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  return OfflineApolloException;
}
var OfflineApolloException;
function RetryOnErrorInterceptor() {
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  return new (DefaultRetryOnErrorInterceptorImpl())(null);
}
var DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass;
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda() {
  if (DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass === VOID) {
    class $ {
      constructor($failFastIfOffline, this$0, $request, $downStream) {
        this.k67_1 = $failFastIfOffline;
        this.l67_1 = this$0;
        this.m67_1 = $request;
        this.n67_1 = $downStream;
      }
      *o67($this$flow, $completion) {
        var tmp;
        if (this.k67_1) {
          var tmp0_safe_receiver = this.l67_1.p67_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q67();
          tmp = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n3()) === false;
        } else {
          tmp = false;
        }
        if (tmp) {
          yield* $this$flow.s1d(Builder().s44(this.m67_1.u43_1, this.m67_1.v43_1).x44(get_OfflineApolloException()).d38(), $completion);
        } else {
          yield* emitAll($this$flow, this.n67_1, $completion);
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o67((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass = $;
  }
  return DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass;
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_0($failFastIfOffline, this$0, $request, $downStream) {
  var i = new (DefaultRetryOnErrorInterceptorImpl$intercept$slambda())($failFastIfOffline, this$0, $request, $downStream);
  var l = ($this$flow, $completion) => i.o67($this$flow, $completion);
  l.$arity = 1;
  return l;
}
var DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0;
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_1() {
  if (DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0 === VOID) {
    class $ {
      constructor($retryOnError, $attempt) {
        this.r67_1 = $retryOnError;
        this.s67_1 = $attempt;
      }
      *o63(it, $completion) {
        if (this.r67_1 && !(it.e45_1 == null) && isRecoverable(ensureNotNull(it.e45_1))) {
          throw RetryException_getInstance();
        } else {
          this.s67_1._v = 0;
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o63(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0 = $;
  }
  return DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0;
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_2($retryOnError, $attempt) {
  var i = new (DefaultRetryOnErrorInterceptorImpl$intercept$slambda_1())($retryOnError, $attempt);
  var l = (it, $completion) => i.o63(it, $completion);
  l.$arity = 1;
  return l;
}
var DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1;
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_3() {
  if (DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1 === VOID) {
    class $ {
      constructor($attempt, this$0) {
        this.t67_1 = $attempt;
        this.u67_1 = this$0;
      }
      *v67($this$retryWhen, cause, _unused_var__etf5q3, $completion) {
        var tmp;
        if (cause instanceof RetryException()) {
          var _unary__edvuaz = this.t67_1._v;
          this.t67_1._v = _unary__edvuaz + 1 | 0;
          if (!(this.u67_1.p67_1 == null)) {
            yield* waitForNetwork(this.u67_1.p67_1, $completion);
          } else {
            Companion_getInstance();
            // Inline function 'kotlin.math.pow' call
            var n = this.t67_1._v;
            // Inline function 'kotlin.time.Companion.seconds' call
            var this_0 = Math.pow(2.0, n);
            var tmp$ret$1 = toDuration(this_0, DurationUnit_SECONDS_getInstance());
            yield* delay(tmp$ret$1, $completion);
          }
          tmp = true;
        } else {
          tmp = false;
        }
        return tmp;
      }
      b5u(p1, p2, p3, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        var tmp_0 = p2 instanceof Error ? p2 : THROW_CCE();
        return this.v67(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'bigint' : false) ? p3 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [3]);
    DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1 = $;
  }
  return DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1;
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_4($attempt, this$0) {
  var i = new (DefaultRetryOnErrorInterceptorImpl$intercept$slambda_3())($attempt, this$0);
  var l = ($this$retryWhen, cause, _unused_var__etf5q3, $completion) => i.v67($this$retryWhen, cause, _unused_var__etf5q3, $completion);
  l.$arity = 3;
  return l;
}
var DefaultRetryOnErrorInterceptorImplClass;
function DefaultRetryOnErrorInterceptorImpl() {
  if (DefaultRetryOnErrorInterceptorImplClass === VOID) {
    class $ {
      constructor(networkMonitor) {
        this.p67_1 = networkMonitor;
      }
      g67(request, chain) {
        var tmp0_elvis_lhs = request.f44_1;
        var failFastIfOffline = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = request.e44_1;
        var retryOnError = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
        if (!failFastIfOffline && !retryOnError) {
          return chain.f67(request);
        }
        var attempt = {_v: 0};
        var downStream = chain.f67(request);
        var tmp = flow(DefaultRetryOnErrorInterceptorImpl$intercept$slambda_0(failFastIfOffline, this, request, downStream));
        var tmp_0 = onEach(tmp, DefaultRetryOnErrorInterceptorImpl$intercept$slambda_2(retryOnError, attempt));
        return retryWhen(tmp_0, DefaultRetryOnErrorInterceptorImpl$intercept$slambda_4(attempt, this));
      }
    }
    initMetadataForClass($, 'DefaultRetryOnErrorInterceptorImpl');
    DefaultRetryOnErrorInterceptorImplClass = $;
  }
  return DefaultRetryOnErrorInterceptorImplClass;
}
function isRecoverable(_this__u8e3s4) {
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  return _this__u8e3s4 instanceof ApolloNetworkException();
}
var RetryExceptionClass;
function RetryException() {
  if (RetryExceptionClass === VOID) {
    class $ extends Exception() {
      static y67() {
        RetryException_instance = null;
        var $this = this.td();
        RetryException_instance = $this;
        captureStack($this, $this.x67_1);
        return $this;
      }
    }
    initMetadataForObject($, 'RetryException');
    RetryExceptionClass = $;
  }
  return RetryExceptionClass;
}
var RetryException_instance;
function RetryException_getInstance() {
  if (RetryException_instance === VOID)
    RetryException().y67();
  return RetryException_instance;
}
var properties_initialized_RetryOnErrorInterceptor_kt_exnoek;
function _init_properties_RetryOnErrorInterceptor_kt__m47hbi() {
  if (!properties_initialized_RetryOnErrorInterceptor_kt_exnoek) {
    properties_initialized_RetryOnErrorInterceptor_kt_exnoek = true;
    OfflineApolloException = ApolloNetworkException().f48('The device is offline', OfflineException_getInstance());
  }
}
//region block: exports
export {
  RetryOnErrorInterceptor as RetryOnErrorInterceptor28nn2rq891clj,
};
//endregion

//# sourceMappingURL=RetryOnErrorInterceptor.mjs.map
